import { Box, Paper, Radio, Typography } from "@mui/material";
import { Analysis, AnalysisPeriod } from "../../../../../app/models/general/analysis";
import { translate } from "../../../../translate/translate";
import TableOnlyBodyComponent from "../../../../../app/components/table/table-only-body.component";
import { useMemo } from "react";

interface AnalysisPeriodPageComponentProps {
  analysis?: Analysis;
  handleSelectPeriod: (week: number) => void;
  selectedPeriod: number | null;
}

interface Periods {
  value: AnalysisPeriod;
  label: string;
}

const SimulationAnalysisPeriodPageComponent = ({ handleSelectPeriod, selectedPeriod }: AnalysisPeriodPageComponentProps) => {

  const periodLabels: Periods[] = [
    { value: AnalysisPeriod.FOUR_WEEKS, weeks: 4, months: 1 },
    { value: AnalysisPeriod.EIGHT_WEEKS, weeks: 8, months: 2 },
    { value: AnalysisPeriod.TWELVE_WEEKS, weeks: 12, months: 3 },
    { value: AnalysisPeriod.SIXTEEN_WEEKS, weeks: 16, months: 4 },
    { value: AnalysisPeriod.TWENTY_FOUR_WEEKS, weeks: 24, months: 6 },
    { value: AnalysisPeriod.THIRTY_TWO_WEEKS, weeks: 32, months: 8 },
    { value: AnalysisPeriod.FORTY_EIGHT_WEEKS, weeks: 48, months: 12 },
  ].map(item => ({
    value: item.value,
    label: `${item.weeks} ${translate.t("weeks")} (${item.months} ${translate.t(item.months === 1 ? "month" : "months")})`,
  }));

  const handleSelectPeriods = (week: number) => {
    handleSelectPeriod(week);
  };

  const renderRadioButton = (period: Periods) => (
    <Box sx={{ display: "flex", alignItems: "center" }} key={period.value} onClick={() => handleSelectPeriods(period.value)}>
      <Radio
        color="primary"
        checked={selectedPeriod === period.value}
        onChange={() => handleSelectPeriods(period.value)}
      />
      {period.label}
    </Box>
  );

  const mappedDataSource = useMemo(() =>
      periodLabels.map((period) => ({
        ...period,
        radioButton: renderRadioButton(period),
      }))
    , [periodLabels, selectedPeriod]);

  const renderCellHandler = (column: string, index: number, row: any) => {
    return column === "radioButton" ? row.radioButton : row[column];
  };

  const headerCellCustomStyleHandler = (column: any) => {
    const baseStyle = {
      backgroundColor: "#FFFF !important",
      color: "var(--primary-main) !important",
      borderBottom: "1px solid var(--primary-main)",
      borderTop: "1px solid var(--primary-main)",
    };
    return column === "customer"
      ? { ...baseStyle, paddingLeft: "54px" }
      : baseStyle;
  };

  return (
    <section>
      <Paper variant="outlined">
        <Box sx={{ borderBottom: "0px solid #4D14AF" }}>
          <Typography
            sx={{
              color: "#4D14AF",
              fontSize: "16px",
              fontWeight: 500,
              paddingLeft: 2,
              paddingTop: 2,
              paddingBottom: 2,
            }}
          >
            {translate.t("period") + ":"}
          </Typography>
        </Box>
        <TableOnlyBodyComponent
          id="table-analysis-period"
          state={mappedDataSource}
          displayedColumns={["radioButton"]}
          renderCellHandler={{ radioButton: renderCellHandler }}
          headerCellCustomStyleHandler={headerCellCustomStyleHandler}
        />
      </Paper>
    </section>
  );
};

export default SimulationAnalysisPeriodPageComponent;
